/**
 * Additional JS for Squeezely personalization, only used by ".slider" elements
 */
setTimeout( () => {
	document.querySelectorAll('.sqzly-personalization').forEach((el) => {
		const slider = el.parentNode;

		// element is not a slider component
		if (!slider.classList.contains('slider')) {
			return;
		}

		// element is not a valid sqzly-recommended container
		if (!slider.classList.contains('sqzly-recommended')) {
			return;
		}

		//el.style.display = 'none';
		let sqzlid = el.getAttribute('id');
		let classes = el.classList;
		let current = slider.querySelectorAll('.music-card');

		setTimeout(function(){
			slider.classList.add( ...classes );
			slider.setAttribute( 'id', sqzlid );
			slider.innerHTML = '';
			current.forEach((item) => {
				slider.appendChild(item);
			});
		}, 250);
	})
}, 1000 );
